import Bowser from 'bowser';

/**
 * Next.jsのgetConfigが使えない環境（TestやStoryboardなど）でのためのUtility
 */
export class GetConfigUtil {
  static getPublicStaticConfig() {
    return {
      IS_DEV: process.env.NEXT_PUBLIC_IS_DEV === 'true',
      ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT!,
      HOST: process.env.NEXT_PUBLIC_HOST!,
      IMGIX_HOST: process.env.NEXT_PUBLIC_IMGIX_HOST!,
      COCOLOCALA_BFF_SERVER_URL: process.env
        .NEXT_PUBLIC_COCOLOCALA_BFF_SERVER_URL!,
      LOGGING_ANY_URL: process.env.NEXT_PUBLIC_LOGGING_ANY_URL!,
      FIREBASE_CONFIG: {
        apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
        authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
        projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
        storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
      },
      USER_SERVICE_GRPC_HOST: process.env.NEXT_PUBLIC_USER_SERVICE_GRPC_HOST!,
      STRIPE_PUBLIC_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!,
      FINCODE_PUBLIC_KEY: process.env.NEXT_PUBLIC_FINCODE_PUBLIC_KEY!,
      SBPS_MERCHANT_ID: process.env.NEXT_PUBLIC_SBPS_MERCHANT_ID!,
      SBPS_SERVICE_ID: process.env.NEXT_PUBLIC_SBPS_SERVICE_ID!,
      SBPS_SCRIPT_URL: process.env.NEXT_PUBLIC_SBPS_SCRIPT_URL!,
      SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN!,
      GOOGLE_ADS_ID: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID!,
      A8_PROGRAM_ID: process.env.NEXT_PUBLIC_A8_PROGRAM_ID!,
      VALUE_COMMERCE: {
        EC_ID: process.env.NEXT_PUBLIC_VALUE_COMMERCE_EC_ID!,
      },
      CRYPTO: {
        HASH_URL: process.env.NEXT_PUBLIC_CRYPT_HASH_URL!,
        ENCRIPT_URL: process.env.NEXT_PUBLIC_CRYPTO!,
      },
    } as const;
  }
}

export const isBrowser = process.browser;

export const isServer = !isBrowser;

export const isPC = (userAgent: string) => {
  return Bowser.parse(userAgent).platform.type === 'desktop';
};

export const isMobile = (userAgent: string) => {
  return !isPC(userAgent);
};

export const isIE = () => {
  if (window && window.navigator && window.navigator.userAgent) {
    return (
      Bowser.parse(window.navigator.userAgent).browser.name ===
      'Internet Explorer'
    );
  } else {
    return false;
  }
};

export const ENVIRONMENT = {
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;
